const getFieldValue = (inputs, ctaKey, pageKey) => {
  const ctaValue = inputs[ctaKey];
  const pageValue = inputs[pageKey];
  return (ctaValue === null || ctaValue === void 0 ? void 0 : ctaValue.value) || (pageValue === null || pageValue === void 0 ? void 0 : pageValue.value);
};
export const getName = inputs => getFieldValue(inputs, 'VARIANT_NAME', 'variantName');
export const getSegmentType = inputs => getFieldValue(inputs, 'SEGMENT_TYPE', 'segmentType');
export const getSegmentId = inputs => getFieldValue(inputs, 'SEGMENT_ID', 'segmentId');

/**
 * Extracts and standardizes execution inputs from AI agent execution data.
 *
 * This function handles two different input formats:
 * - CTA format: Uses uppercase keys (SEGMENT_TYPE, SEGMENT_ID, PROMPT, VARIANT_NAME, EXISTING_WEB_INTERACTIVE_ID)
 * - Landing Page/Website Page format: Uses camelCase keys (segmentType, segmentId, prompt, variantName, originalPageId)
 *
 * The function attempts to find values using both key formats and returns the first non-null value found.
 *
 * @param inputs - Record containing field values from AI agent execution, with either CTA or Landing Page/Website Page format keys
 * @returns ExtractedExecutionInputs - Standardized object containing segmentType, segmentId, prompt, variantName, and assetId
 */
export const getExecutionInputs = inputs => {
  var _getFieldValue;
  return {
    segmentType: getFieldValue(inputs, 'SEGMENT_TYPE', 'segmentType'),
    segmentId: getFieldValue(inputs, 'SEGMENT_ID', 'segmentId'),
    prompt: getFieldValue(inputs, 'PROMPT', 'prompt'),
    variantName: getFieldValue(inputs, 'VARIANT_NAME', 'variantName'),
    assetId: (_getFieldValue = getFieldValue(inputs, 'EXISTING_WEB_INTERACTIVE_ID', 'originalPageId')) === null || _getFieldValue === void 0 ? void 0 : _getFieldValue.toString()
  };
};